import "./App.css";
import AboutUs from "./components/aboutus/aboutus.component";
import Footer from "./components/footer/footer.component";
import Hero from "./components/hero/hero.component";
import Navbar from "./components/navbar/navbar.component";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Services from "./components/services/services.component";
import Reviews from "./components/reviews/reviews.component";
import Gallery from "./components/gallery/gallery.component";
import ContactUs from "./components/contactus/contactus.component";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <AboutUs />
      <Services />
      <Reviews />
      <Gallery />
      <ContactUs />
      <Footer />
    </div>
  );
}

export default App;
